import "./App.css";
import React, { useEffect, useLayoutEffect, useState } from "react";
import Login from "./comp/Login/Login";
import MainPage from "./comp/MainPage";
import GrantRequest from "./comp/GrantRequest";
import ButtonAppBar from "./comp/ButtonAppBar";
import avatarPic from "./comp/avatar.jpg";

import ChatBot from "react-simple-chatbot";

import Ngos from "./comp/Ngos";
import Notifications from "./comp/Notifications";
import Status from "./comp/Status";
import GrantHistory from "./comp/GrantHistory";
import Testin from "./comp/Testin";
import Auth from "./utilities/Auth";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";
import {
  AccountsData,
  GlobalData,
  UserData,
  UserFavoritesNgos,
} from "./Contexts";
import NewRequest from "./comp/NewRequest";
import { ThemeProvider, useMediaQuery } from "@material-ui/core";
import theme from "./comp/themes";
import { useLanguageFromQuery } from "./useLanguageFromQuery";
import MultiUser from "./comp/MultiUser";
import Files from "./comp/Files";
import { proxy } from "valtio";
import Itrot from "./comp/Itrot";
import initFb from "./utilities/firebaseConfig";
import { chatWithBot } from "./utilities/api";

export const globalState = proxy({ id: null, fireBaseApp: null });

window.appVersion = "1.0";
function App() {
  const screenSize = useMediaQuery("(min-width:600px)");
  const [language, setLanguage] = React.useState("he");
  const [userData, setUserData] = React.useState();
  const [userFavoritesNgos, setUserFavoritesNgos] = React.useState();
  const [userAccounts, setUserAccounts] = React.useState();

  useLayoutEffect(() => {
    initFb();
  }, []);

  useLanguageFromQuery(setLanguage, language);
  const dir = language === "he" ? "rtl" : "ltr";
  document.documentElement.dir = dir;

  const BotApiResponse = (props) => {
    const [answer, setAnswer] = useState();

    useEffect(() => {
      if (answer) {
        const container = document.querySelector(".rsc-content");
        container.scrollBy({ top: container.scrollHeight, behavior: "smooth" });
      }
    }, [answer]);
    const question = props.previousStep.value;
    useEffect(() => {
      chatWithBot(question)
        .then((data) => {
          setAnswer(data.data.answer + "\n \n יש לך שאלה נוספת...?");
        })
        .catch((err) => {
          console.log(err);
          setAnswer("הייתה בעיה בגישה לבוט! אנא נסה שנית או פנה לתמיכה");
        });
    }, [question]);
    return <span>{answer || "תנו לי לחשוב על זה..."}</span>;
  };

  const [steps] = useState([
    {
      id: "3",
      message: "איך אפשר לעזור היום?",
      trigger: "4",
    },
    { id: "4", user: true, trigger: "answer" },
    {
      id: "answer",
      asMessage: true,
      component: <BotApiResponse />,
      trigger: "4",
    },
  ]);
  const [chatBot, setChatbot] = useState(false);
  return (
    <GlobalData.Provider value={{ screenSize, language, setLanguage }}>
      {/* {userData && (
        <ChatBot
          floating
          placeholder={"מה ברצונך לשאול?"}
          headerTitle={"שוחחו עם מאיה"}
          botAvatar={avatarPic}
          floatingStyle={{ background: "rgba(0, 78, 94, 1)" }}
          opened={chatBot}
          toggleFloating={() => {
            setChatbot(!chatBot);
          }}
          steps={steps}
        />
      )} */}
      <AccountsData.Provider value={[userAccounts, setUserAccounts]}>
        <UserData.Provider value={[userData, setUserData]}>
          <UserFavoritesNgos.Provider
            value={[userFavoritesNgos, setUserFavoritesNgos]}
          >
            <ThemeProvider theme={theme}>
              <Router>
                <div className="App">
                  <Route path="/landing-mail">
                    <MailLanding />
                  </Route>
                  {userData && <ButtonAppBar></ButtonAppBar>}
                  <Switch>
                    <Route path="/login">
                      <Login
                        setUserData={setUserData}
                        setUserFavoritesNgos={setUserFavoritesNgos}
                      />
                    </Route>

                    <Route path="/multi">
                      <MultiUser />
                    </Route>

                    <Route exact path="/grantrequest">
                      <Auth>
                        {" "}
                        <GrantRequest />
                      </Auth>
                    </Route>
                    <Route exact path="/ngos">
                      <Auth>
                        {" "}
                        <Ngos />
                      </Auth>
                    </Route>
                    <Route exact path="/files">
                      <Auth>
                        {" "}
                        <Files />
                      </Auth>
                    </Route>
                    <Route exact path="/itrot">
                      <Auth>
                        {" "}
                        <Itrot />
                      </Auth>
                    </Route>
                    <Route exact path="/notifications">
                      <Auth>
                        {" "}
                        <Notifications />
                      </Auth>
                    </Route>
                    <Route exact path="/status">
                      <Auth>
                        {" "}
                        <Status />
                      </Auth>
                    </Route>
                    <Route exact path="/granthistory">
                      <Auth>
                        {" "}
                        <GrantHistory />
                      </Auth>
                    </Route>
                    <Route exact path="/testing">
                      {" "}
                      <Testin />
                    </Route>

                    <Route exact path="/">
                      <Auth>
                        {" "}
                        <MainPage />
                      </Auth>
                    </Route>
                    <Route exact path="/newrequest">
                      <Auth>
                        {" "}
                        <NewRequest />
                      </Auth>
                    </Route>
                  </Switch>
                </div>
              </Router>
            </ThemeProvider>
          </UserFavoritesNgos.Provider>
        </UserData.Provider>
      </AccountsData.Provider>
    </GlobalData.Provider>
  );
}

export default App;

const MailLanding = () => {
  return <div></div>;
};
